import { redirect } from "@tanstack/react-router";

import { Version } from "@/lib/types/version";
import { getAppInfo } from "@/lib/utils/app-info";
import type { RouteGuard } from "@/routes/-root/root-guards";

export const guardAppVersion: RouteGuard = async ({ context, location }) => {
  const appInfo = await getAppInfo();
  const actualVersion = new Version(appInfo.version);
  const minimalVersion = context.ldClient.getMinimalAppVersion();
  const isExpiredVersion = actualVersion.lowerThan(minimalVersion);

  if (isExpiredVersion && location.pathname !== "/update-required") {
    redirect({
      to: "/update-required",
      search: { redirect: location.href },
      throw: true,
    });
  }

  if (!isExpiredVersion && location.pathname === "/update-required") {
    redirect({
      to: "/",
      throw: true,
    });
  }
};

export const guardInactiveUser: RouteGuard = ({ context, location }) => {
  if (!context.user.ativo && location.pathname !== "/access-blocked") {
    redirect({
      to: "/access-blocked",
      search: { redirect: location.href },
      throw: true,
    });
  }

  if (context.user.ativo && location.pathname === "/access-blocked") {
    redirect({
      to: "/",
      throw: true,
    });
  }
};
